import { useLocation, useNavigate } from "react-router-dom";

import dayjs, { Dayjs } from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";

import { useSelectedDate } from "../../../shared/hooks/use-selected-date";

import {
  StyledContainer,
  StyledButton,
  GlobalStylesArrowSwitcher,
} from "./arrow-switcher.style";

import { DatePicker } from "antd";
import { useState } from "react";

dayjs.extend(updateLocale);

dayjs.updateLocale("en", {
  months: [
    "Студзень",
    "Люты",
    "Сакавiк",
    "Красавiк",
    "Май",
    "Чэрвень",
    "Лiпень",
    "Жнiвень",
    "Верасень",
    "Кастрычнiк",
    "Лiстапад",
    "Снежань",
  ],
});

export const ArrowSwitcher = () => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const selectedDate = useSelectedDate();

  const monthYear = selectedDate ? selectedDate.format("MMMM YYYY") : "";

  const handleSwitch = (newDate: Dayjs) => {
    navigate(`/?date=${JSON.stringify(newDate)}`, { replace: true });
  };

  const handleDateChange = (newDate: Dayjs, dateString: string | string[]) => {
    navigate(`/?date=${JSON.stringify(newDate)}`, { replace: true });
  };

  const customFormat = (value: Dayjs) => {
    return value ? dayjs(value).format("MMMM YYYY") : "";
  };

  return (
    <StyledContainer>
      <GlobalStylesArrowSwitcher />
      <StyledButton
        onClick={() => handleSwitch(selectedDate.subtract(1, "month"))}
      >
        &lt;
      </StyledButton>

      {/* <StyledTextButton onClick={() => setOpen(!open)}>
        <span>{monthYear.toUpperCase()}</span>
      </StyledTextButton> */}

      <DatePicker
        onChange={handleDateChange}
        picker="month"
        open={open}
        className="datePicker"
        style={{ maxWidth: `18rem`, minWidth: `18rem` }}
        value={selectedDate}
        format={customFormat}
        onOpenChange={(open) => setOpen(open)}
        minDate={dayjs('2024-01-01')}
        maxDate={dayjs('2026-12-31')} 
      />

      <StyledButton onClick={() => handleSwitch(selectedDate.add(1, "month"))}>
        &gt;
      </StyledButton>
    </StyledContainer>
  );
};
